<p-toggleswitch [(ngModel)]="isChecked" [disabled]="disabled" (onChange)="onChanged($event)" />
